export default "__VITE_ASSET__BzaSKzmj__"